import React from 'react'
import ContentLoader from 'react-content-loader'

export const ProfileSubscriptionTitleLoader = () => {
    return (
        <ContentLoader height={'50px'}>
            <rect height={'30px'} width={'220px'} />
            <rect height={'16px'} width={'280px'} y={'35px'} />
        </ContentLoader>
    )
}

export const NextPaymentLoader = () => (
    <ContentLoader width={'100%'} height={'48px'}>
        <rect width={'100%'} height={'48px'} rx={'4px'} ry={'4px'} />
    </ContentLoader>
)

export const PaymentHistoryLoader = () => (
    <ContentLoader width={'100%'}>
        <rect width={'100%'} height={'48px'} />
        <rect width={'100%'} height={'48px'} y={'50px'} />
        <rect width={'100%'} height={'48px'} y={'100px'} />
    </ContentLoader>
)
